import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NewHomePage from "@/pages/NewHomePage";
import EarlyAccessPage from "@/pages/EarlyAccessPage";
import ContactPage from "@/pages/ContactPage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import SciencePage from "@/pages/SciencePage";
import AboutPage from "@/pages/AboutPage";
import RefundPolicyPage from "@/pages/RefundPolicyPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<NewHomePage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:slug" element={<ProductDetailPage />} />
          <Route path="/early-access" element={<EarlyAccessPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/science" element={<SciencePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
